import { computed } from 'vue'
import { getGeneralAction } from '@/api/functions/general/get-general.action'
import paypal from '/svg/paypal.svg'
import revolut from '/svg/revolut.svg'
import transferBank from '/svg/Transfer-bank.svg'
import { useQueryApi } from './useApi'

export function useGeneralSettings() {
  const {
    data: settingsResponse,
    isLoading,
    isError,
  } = useQueryApi({
    queryKey: ['settings'],
    queryFn: getGeneralAction,
  })

  const currencies = computed(() => {
    const data = settingsResponse.value?.data?.currencies || []
    return data.map((currency) => ({
      label: currency.titleFa,
      value: currency.id,
      ...currency,
      commissionRates: currency.commissionRates || [],
      margins: currency.margins || { selling: 0, buying: 0 },
      titleFa: currency.titleFa,
      titleEn: currency.titleEn,
    }))
  })

  const transferMethods = computed(() => {
    const data = settingsResponse.value?.data?.transferMethods || []

    return data.map((method) => {
      let icon = ''

      switch (method.title) {
        case 'Bank Transfer':
          icon = transferBank
          break

        case 'Paypal':
          icon = paypal
          break

        case 'Revolut (just revolut  possible)':
        case 'Revolut':
        case 'Revolut (bank transfer possible)':
          icon = revolut
          break
      }

      return {
        label: method.label,
        title: method.title,
        value: method.id,
        icon,
      }
    })
  })

  const countries = computed(() => {
    const data = settingsResponse.value?.data?.countries || []
    return data.map((country) => ({
      label: country.title.fa,
      value: country.id,
      flagUrl: country.flagUrl,
      iso: country.iso,
    }))
  })

  const bankAccounts = computed(() => {
    const data = settingsResponse.value?.data?.bankAccounts || {}
    return {
      charity: data.charity || [],
      provider: data.provider || [],
    }
  })

  const allBankAccounts = computed(() => {
    const data = settingsResponse.value?.data?.bankAccounts || {}
    const charityAccounts = data.charity || []
    const providerAccounts = data.provider || []

    return [...charityAccounts, ...providerAccounts]
  })

  const charityBankAccounts = computed(() => {
    const data = settingsResponse.value?.data?.bankAccounts || {}
    return data.charity || []
  })

  const providerBankAccounts = computed(() => {
    const data = settingsResponse.value?.data?.bankAccounts || {}
    return data.provider || []
  })

  const statusOptions = computed(() => {
    const statuses = settingsResponse.value?.data?.requisitions?.enums?.requisitionStatus || {}

    return Object.entries(statuses).map(([value, label]) => ({
      label,
      value,
    }))
  })

  const offersStatusOptions = computed(() => {
    const statuses = settingsResponse.value?.data?.offers?.enums?.offerStatus || {}

    return Object.entries(statuses).map(([value, label]) => ({
      label,
      value,
    }))
  })

  const transactionsStatusOptions = computed(() => {
    const statuses = settingsResponse.value?.data?.transactions?.enums?.transactionStatus || {}

    return Object.entries(statuses).map(([value, label]) => ({
      label,
      value,
    }))
  })

  const discountOptions = computed(() => [
    { label: 'دارای تخفیف', value: 'true' },
    { label: 'بدون تخفیف', value: 'false' },
  ])

  const userStatusOptions = computed(() => {
    const statuses = settingsResponse.value?.data?.users?.enums?.userStatus || {}

    return Object.entries(statuses).map(([value, label]) => ({
      label,
      value,
    }))
  })

  const referralOptions = computed(() => {
    const referrals = settingsResponse.value?.data?.users?.enums?.userReferralType || {}

    return Object.entries(referrals).map(([value, label]) => ({
      label,
      value,
    }))
  })

  const offerTypeOptions = computed(() => {
    const types = settingsResponse.value?.data?.offers?.enums?.offerType || {}

    return Object.entries(types).map(([value, label]) => ({
      label,
      value,
    }))
  })

  const discountTypeOptions = computed(() => {
    //  TODO  @hana : discountTypes
    const types = settingsResponse.value?.data?.types || []

    return types.map((type) => ({
      label: type.titleFa,
      value: type.id,
      title: type.title,
      titleFa: type.titleFa,
    }))
  })

  return {
    currencies,
    transferMethods,
    countries,
    bankAccounts,
    allBankAccounts,
    charityBankAccounts,
    providerBankAccounts,
    statusOptions,
    offersStatusOptions,
    transactionsStatusOptions,
    discountOptions,
    offerTypeOptions,
    userStatusOptions,
    referralOptions,
    isLoading,
    isError,
    discountTypeOptions,
    settings: settingsResponse,
  }
}
